import { jsx as _jsx } from "react/jsx-runtime";
import { Motion } from '#pplx/frontend/aether/components/Motion/index.js';
import { useTabsContext } from '#pplx/frontend/aether/components/Tabs/TabsContext.js';
import { useRadixProps } from '#pplx/frontend/aether/internal/useRadixProps.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import * as TabsPrimitive from '@radix-ui/react-tabs';
export function TabsPanel({ value, children, ...props }) {
    const __radixProps = useRadixProps(props);
    const { currentValue, animation = 'none' } = useTabsContext();
    const isActive = currentValue === value;
    const isAnimated = animation !== 'none';
    const content = (_jsx(TabsPrimitive.Content, { value: value, className: "focus:outline-hidden", forceMount: isAnimated || undefined, ...__radixProps, children: children }));
    switch (animation) {
        case 'fade':
            return (_jsx(Motion.Fade, { isVisible: isActive, className: "col-start-1 row-start-2", children: content }));
        case 'none':
            return content;
        default:
            assertUnreachableValue(animation);
    }
}
//# sourceMappingURL=TabsPanel.js.map